import { getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDeh_jMeSd2yfx41aoqG7kZtl3e2-clZjo',
  authDomain: 'school-of-shem.firebaseapp.com',
  databaseURL: 'https://school-of-shem-default-rtdb.firebaseio.com',
  projectId: 'school-of-shem',
  storageBucket: 'school-of-shem.firebasestorage.app',
  messagingSenderId: '784617089691',
  appId: '1:784617089691:web:adcde2ab8311e7835a743e',
  measurementId: 'G-QEJDFVL35H'
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const getSecondaryAuth = () => {
  const existing = getApps().find(existingApp => existingApp.name === 'secondary-auth');
  const secondaryApp = existing || initializeApp(firebaseConfig, 'secondary-auth');
  return getAuth(secondaryApp);
};

const initAnalytics = () => {
  if (typeof window === 'undefined') return null;
  return isSupported().then((supported) => (supported ? getAnalytics(app) : null));
};

export { app, auth, db, storage, initAnalytics, getSecondaryAuth };
